import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AnalysisResultCategory } from '../models';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class AnalysisResultCategoriesService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createAnalysisResultCategory(
    payload: AnalysisResultCategory
  ): Observable<AnalysisResultCategory> {
    return this.rolesService.userHasRoleFilter<AnalysisResultCategory>(
      'ROLE_MWS_ANALYSIS_RESULT_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/analysis_result_categories`, payload)
    );
  }

  readAnalysisResultCategory(iri: string): Observable<AnalysisResultCategory> {
    return this.rolesService.userHasRoleFilter<AnalysisResultCategory>(
      'ROLE_MWS_ANALYSIS_RESULT_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readAnalysisResultCategories(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_ANALYSIS_RESULT_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(`/analysis_result_categories`)
    );
  }

  updateAnalysisResultCategory(
    iri: string,
    payload: AnalysisResultCategory
  ): Observable<AnalysisResultCategory> {
    return this.rolesService.userHasRoleFilter<AnalysisResultCategory>(
      'ROLE_MWS_ANALYSIS_RESULT_EDIT',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.updateObject(iri, payload, true)
    );
  }

  deleteAnalysisResultCategory(iri: string): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_ANALYSIS_RESULT_DELETE',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.deleteObject(iri, true)
    );
  }
}
